export let BillableStateType;

(function (BillableStateType) {
  BillableStateType["Billable"] = "billable";
  BillableStateType["NonBillable"] = "nonBillable";
})(BillableStateType || (BillableStateType = {}));

export let NonBillableReason;

(function (NonBillableReason) {
  NonBillableReason["IssuingInvoice"] = "issuingInvoice";
  NonBillableReason["BilledMaxCharges"] = "billedMaxCharges";
})(NonBillableReason || (NonBillableReason = {}));